import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useSystemTheme } from '@indriver/nova-core';
import React__default, { createContext, useMemo, useState, useEffect } from 'react';
import { Box } from './theme-provider.styles.js';

var DEFAULT_THEME = 'theme-light';
var ThemeContext = /*#__PURE__*/createContext({
  theme: DEFAULT_THEME,
  setTheme: function setTheme() {}
});

var convertSystemThemeToOymyakonTheme = function convertSystemThemeToOymyakonTheme(systemTheme) {
  if (!systemTheme) {
    return DEFAULT_THEME;
  }

  return "theme-" + systemTheme;
};

var ThemeProvider = function ThemeProvider(_ref) {
  var value = _ref.value,
      children = _ref.children,
      _ref$wrapped = _ref.wrapped,
      wrapped = _ref$wrapped === void 0 ? true : _ref$wrapped,
      _ref$autoDetectTheme = _ref.autoDetectTheme,
      autoDetectTheme = _ref$autoDetectTheme === void 0 ? true : _ref$autoDetectTheme;
  var shouldWeConsiderAutoTheme = useMemo(function () {
    return value ? false : autoDetectTheme;
  }, [autoDetectTheme, value]);

  var _useSystemTheme = useSystemTheme(),
      systemTheme = _useSystemTheme.systemTheme;

  var defaultTheme = autoDetectTheme ? convertSystemThemeToOymyakonTheme(systemTheme) : DEFAULT_THEME;

  var _useState = useState(value != null ? value : defaultTheme),
      theme = _useState[0],
      setTheme = _useState[1];

  useEffect(function () {
    if (shouldWeConsiderAutoTheme) {
      setTheme(convertSystemThemeToOymyakonTheme(systemTheme));
    }
  }, [systemTheme, shouldWeConsiderAutoTheme]);
  var contextValue = useMemo(function () {
    return {
      theme: theme,
      setTheme: setTheme
    };
  }, [theme]);

  var buildChildren = function buildChildren(childContent) {
    var _React$Children$map;

    return (_React$Children$map = React__default.Children.map(childContent, function (child) {
      if (!child || !child.type) {
        return child;
      }

      var childProps = {};

      if (child.type === React__default.Fragment) {
        childProps = _extends({}, child.props, {
          children: buildChildren(child.props.children)
        });
      } else {
        childProps = _extends({}, child.props, {
          className: theme + " " + child.props.className
        });
      }

      return /*#__PURE__*/React__default.cloneElement(child, childProps);
    })) == null ? void 0 : _React$Children$map.filter(Boolean);
  };

  return /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: contextValue
  }, wrapped ? /*#__PURE__*/React__default.createElement(Box, {
    className: theme
  }, children) : buildChildren(children));
};

export { ThemeContext, ThemeProvider };
